if (!customElements.get('lazy-load-section')) {
    class LazyLoadSection extends HTMLElement {
        constructor() {
            super();
            this.elements = {
              lazyLoadSection: this.querySelector('.lazyload-wrapper'),
              lazyLoadContent: this.querySelector(`#lazyload-${this.getAttribute('data-id')}`),
              videoUrl:  this.querySelector('.lazyload-wrapper').getAttribute('data-video-url')
            };

           this.observer = new IntersectionObserver(this.handleIntersection.bind(this));   
          }
    
          connectedCallback() {
            this.observer.observe(this);
          }
        
          disconnectedCallback() {
            this.observer.unobserve(this);
          }
        
          loadFeaturedScript() {
            this.elements.lazyLoadSection.innerHTML = JSON.parse(this.elements.lazyLoadContent.getAttribute('section-content'));
          }
        
          handleIntersection(entries) {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                  
                    console.log(entry.isIntersecting + this  + 'loaded');
                    this.loadFeaturedScript();
                    this.disconnectedCallback();
                  }
            })
          }

        }
        customElements.define('lazy-load-section', LazyLoadSection);
}   